import React from 'react';
import classnames from 'classnames';
import { withMatureContext } from '@wix/da-react-context/pkg/MatureContext';
import DOMPurify from 'isomorphic-dompurify';
import { useSafeUrlHandler } from '../SafeUrlModal/hooks/useSafeUrlHandler';
import s from './LegacyTextRenderer.scss';
function createMarkup(text) {
    return {
        __html: DOMPurify.sanitize(text, {
            FORCE_BODY: true,
            ADD_TAGS: [
                'iframe'
            ]
        })
    };
}
export const LegacyTextRenderer = /*#__PURE__*/ React.forwardRef(({ html, className, theme, showMatureContent, disableStyles, withSafetyCheckModal }, ref)=>{
    const safeUrlHandler = useSafeUrlHandler();
    if (!html) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: classnames('legacy-journal', !disableStyles && theme && s['legacy'], !disableStyles && theme && s[theme], !showMatureContent && 'maturefilter', className),
        dangerouslySetInnerHTML: createMarkup(html),
        ref: ref,
        onClickCapture: withSafetyCheckModal ? safeUrlHandler : undefined
    }));
});
LegacyTextRenderer.displayName = 'LegacyTextRenderer';
export default withMatureContext(LegacyTextRenderer);
